function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.58752 0H14.5875C17.9012 0 20.5875 2.68629 20.5875 6V14C20.5875 17.3137 17.9012 20 14.5875 20H6.58752C3.27382 20 0.587524 17.3137 0.587524 14V6C0.587524 2.68629 3.27382 0 6.58752 0ZM6.58752 2C4.37839 2 2.58752 3.79086 2.58752 6V14C2.58752 16.2091 4.37839 18 6.58752 18H14.5875C16.7967 18 18.5875 16.2091 18.5875 14V6C18.5875 3.79086 16.7967 2 14.5875 2H6.58752Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.58752 7H6.58752C6.03524 7 5.58752 7.44772 5.58752 8V12C5.58752 12.5523 6.03524 13 6.58752 13H9.58752",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5875 7H13.5875C13.0352 7 12.5875 7.44772 12.5875 8V12C12.5875 12.5523 13.0352 13 13.5875 13H16.5875",
  stroke: "currentColor",
  strokeWidth: 2
});

function SvgSubtitles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitles);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41ODc1MiAwSDE0LjU4NzVDMTcuOTAxMiAwIDIwLjU4NzUgMi42ODYyOSAyMC41ODc1IDZWMTRDMjAuNTg3NSAxNy4zMTM3IDE3LjkwMTIgMjAgMTQuNTg3NSAyMEg2LjU4NzUyQzMuMjczODIgMjAgMC41ODc1MjQgMTcuMzEzNyAwLjU4NzUyNCAxNFY2QzAuNTg3NTI0IDIuNjg2MjkgMy4yNzM4MiAwIDYuNTg3NTIgMFpNNi41ODc1MiAyQzQuMzc4MzkgMiAyLjU4NzUyIDMuNzkwODYgMi41ODc1MiA2VjE0QzIuNTg3NTIgMTYuMjA5MSA0LjM3ODM5IDE4IDYuNTg3NTIgMThIMTQuNTg3NUMxNi43OTY3IDE4IDE4LjU4NzUgMTYuMjA5MSAxOC41ODc1IDE0VjZDMTguNTg3NSAzLjc5MDg2IDE2Ljc5NjcgMiAxNC41ODc1IDJINi41ODc1MloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgPHBhdGggZD0iTTkuNTg3NTIgN0g2LjU4NzUyQzYuMDM1MjQgNyA1LjU4NzUyIDcuNDQ3NzIgNS41ODc1MiA4VjEyQzUuNTg3NTIgMTIuNTUyMyA2LjAzNTI0IDEzIDYuNTg3NTIgMTNIOS41ODc1MiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggZD0iTTE2LjU4NzUgN0gxMy41ODc1QzEzLjAzNTIgNyAxMi41ODc1IDcuNDQ3NzIgMTIuNTg3NSA4VjEyQzEyLjU4NzUgMTIuNTUyMyAxMy4wMzUyIDEzIDEzLjU4NzUgMTNIMTYuNTg3NSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };